import { useMemo } from 'react';
import { callDeepLink } from '@croquiscom-pvt/web2app';

import { isZigzag } from '@common/device-manager';
import { PdpProductSizeType } from '@domains/pdp-common';

import { useSizeRecommendationService } from './useSizeRecommendationService';

export const useSimilarSizeService = () => {
  const { catalogProductId, recommendationType, recommendOptionValueList, userAccount, isReviewButtonVisible } =
    useSizeRecommendationService();

  const isPurchaseType = recommendationType === PdpProductSizeType.PURCHASE;
  const isOptionType = recommendationType === PdpProductSizeType.OPTION;

  // 상위 2개 옵션만 노출
  const displayedOptions = useMemo(() => {
    return recommendOptionValueList?.slice(0, 2) || [];
  }, [recommendOptionValueList]);

  // 추천 사이즈 텍스트 (Subtitle에서 사용)
  const recommendSizeText = useMemo(() => {
    if (!recommendOptionValueList || recommendOptionValueList.length === 0) {
      return '';
    }
    // 1위인 옵션들의 이름을 콤마로 연결
    return recommendOptionValueList
      .filter((option: any) => option.ranking === 1)
      .map((option: any) => option.name)
      .join(', ');
  }, [recommendOptionValueList]);

  const handleReviewClick = () => {
    if (isZigzag()) {
      const deeplink = `/browser_product_review?product_id=${catalogProductId}&is_checked_my_custom_filter=true`;
      callDeepLink(deeplink)();
    } else {
      location.assign(`/review/list/${catalogProductId}?filter=my_custom`);
    }
  };

  const handleUserFigureClick = () => {
    const BODY_PROFILE_SETTING_PAGE = '/profile/body';
    const url = `${location.origin}${BODY_PROFILE_SETTING_PAGE}`;

    if (isZigzag()) {
      callDeepLink('/full_screen_simple_browser')({
        url: encodeURIComponent(url),
      });
    } else {
      location.assign(url);
    }
  };

  return {
    userAccount,
    isPurchaseType,
    isOptionType,
    recommendSizeText,
    displayedOptions,
    isReviewButtonVisible,
    onReviewClick: handleReviewClick,
    onUserFigureClick: handleUserFigureClick,
  };
};
